import cloud2 from '../../images/cloud-2.png';
import cloud3 from '../../images/cloud-3.png';
import cloud5 from '../../images/cloud-5.png';
import cloud4 from '../../images/cloud-4.png';
import googlecloud from '../../images/google-cloud.png';

interface summaryType{
  service_type: string,
  reference_name:string,
  note: string,
  meta_key_value_fields: MetaKeyValueFields,
}
interface MetaKeyValueFields {
    [key: string]: string | number;
}
interface props{
    data:summaryType
}
const Summary = ({ data }:props) => {
  const getImage = (val: any) => {
    switch (val.toLowerCase()) {
      case 'aws': return cloud3;
      case 'digitalocean': return cloud2;
      case 'azure': return cloud5;
      case 'ibm': return cloud4;
      case 'googlecloud': return googlecloud;
      case 'gcp': return googlecloud;
      case 'google': return googlecloud;
      default: return cloud3;
    }
  };
  const checkEmpty = () => !(Object.keys(data).length === 0 && data.constructor === Object);
  return (
        <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 mx-auto cloud-details p-0 marginauto">
            <div className="mx-4 pb-4 border-bottom nonActiveTabColor">
                <h6 className="mt-4 mb-5">QUICK SUMMARY</h6>
                {!data && <h6 className="text-center">Error No Data</h6>}
                {data && checkEmpty()
                && (
                <>
                    <div className="d-flex justifycontent ">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-8">
                            <p><strong>Service Type:</strong></p>
                        </div>
                        <div className="col-6">
                            <p className="color-fabric">{data.service_type}</p>
                        </div>
                    </div>
                    <div className="d-flex justifycontent">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-8">
                            <p><strong>Reference Name:</strong></p>
                        </div>
                        <div className="col-6">
                            <p className="color-fabric">{data.reference_name}</p>
                        </div>
                    </div>
                </>
                )}
            </div>
            {data && checkEmpty()
            && (
                <>
                    <div className="mx-4 pb-4 mt-5 border-bottom">
                    { Object.entries(data.meta_key_value_fields).map(([key, value]) => (
                        <div key={`details-${key.toString()}`} className="d-flex justifycontent">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-8">
                                <p><strong>{`${key}:`}</strong></p>
                            </div>
                            <div className="col-6">
                                <p className="color-fabric">
                                    { key === 'Cloud' && <img className="mx-1" src={getImage(value)} alt="" height="20px" />}
                                    {`${value}`}
                                </p>
                            </div>
                        </div>
                    ))}
                    </div>
                    <p className="px-4 mt-3 text-secondary">{`Note: ${data.note}`}</p>
                </>
            )}
        </div>
  );
};

export default Summary;